import React from "react";
import { DollarSign, TrendingUp } from "lucide-react";

interface QuickActionsMenuProps {
  showQuickActionsMenu: boolean;
  onTriggerAction: (actionName: string) => void;
  onClose: () => void;
  actionsConfig?: {
    enableFinancialSummary: boolean;
    enableOpportunityCost: boolean;
  };
}

const QuickActionsMenu: React.FC<QuickActionsMenuProps> = ({
  showQuickActionsMenu,
  onTriggerAction,
  onClose,
  actionsConfig = {
    enableFinancialSummary: true,
    enableOpportunityCost: true,
  },
}) => {
  if (!showQuickActionsMenu) {
    return null;
  }

  // Check if at least one action is enabled
  const hasEnabledActions = actionsConfig.enableFinancialSummary || actionsConfig.enableOpportunityCost;

  if (!hasEnabledActions) {
    return null;
  }

  return (
    <>
      <div className="fixed inset-0 z-30" onClick={onClose}></div>
      <div className="absolute bottom-16 right-4 mb-2 w-56 bg-[#1e1e1e] text-white rounded-xl shadow-2xl border border-gray-700 py-1.5 z-50 animate-in fade-in zoom-in-95 slide-in-from-bottom-2">
        <div className="px-3 py-2 border-b border-gray-700 mb-1">
          <span className="text-[10px] uppercase font-bold text-gray-400 tracking-wider">
            Quick Analysis
          </span>
        </div>

        {actionsConfig.enableFinancialSummary && (
          <button
            onClick={() => onTriggerAction("Financial Summary")}
            className="w-full text-left px-3 py-2.5 text-xs flex items-center gap-3 hover:bg-gray-700 transition"
          >
            <DollarSign size={14} className="text-green-400" />
            <span>Financial Summary</span>
          </button>
        )}

        {actionsConfig.enableOpportunityCost && (
          <button
            onClick={() => onTriggerAction("Opportunity Cost")}
            className="w-full text-left px-3 py-2.5 text-xs flex items-center gap-3 hover:bg-gray-700 transition"
          >
            <TrendingUp size={14} className="text-purple-400" />
            <span>Opportunity Cost</span>
          </button>
        )}
      </div>
    </>
  );
};

export default QuickActionsMenu;
